var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Bar',{attrs:{"width":_vm.width,"height":_vm.height,"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }